import React from "react";

function Linesvg({ IconHeight, IconWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={IconWidth}
      height={IconHeight}
      fill="currentColor"
      class="bi bi-list"
      viewBox="0 2 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
      />
    </svg>
  );
}

export default Linesvg;
